import { lazy, Suspense, useRef } from "react"
import { Navigate, useSearchParams } from "react-router-dom"

const IssueReport = lazy(() => import("./components/organisms/IssueReport"))
const ScopeReport = lazy(() => import("./components/organisms/ScopeReport"))

export const Reports = () => {
  const [searchParams] = useSearchParams()
  const type = searchParams.get("report_type")
  const onReady = useRef(() => {
    if (typeof window !== "undefined")
      (window as Window & { reportReady?: boolean }).reportReady = true
  }).current

  if (type === "REPORT_TYPE_ISSUE_SUMMARY")
    return (
      <Suspense>
        <IssueReport onReady={onReady} />
      </Suspense>
    )

  if (type === "REPORT_TYPE_SCOPE_SUMMARY")
    return (
      <Suspense>
        <ScopeReport onReady={onReady} />
      </Suspense>
    )

  return <Navigate to="/" />
}
